import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { ACCOUNT_QUERY_KEY } from '@hcs/http-clients';
import { useToastSlice } from '@hcs/toast';

import { AuthnApi } from '../api';

export const useAccount = () => {
  const {
    actions: { toastOpen },
  } = useToastSlice();
  const accountQuery = useQuery({
    queryKey: [ACCOUNT_QUERY_KEY],
    queryFn: async () => {
      return await AuthnApi.fetchAccount();
    },
    retry: 1,
  });

  const { isError, error } = accountQuery;
  useEffect(() => {
    if (isError) {
      if (isAxiosError(error)) {
        // Handle specific error codes if needed
        if (error.response?.status === 402 && error.response.data.message) {
          // Show a message with a payment related error
          toastOpen({
            type: 'error',
            title: error.response.data.message,
            duration: 15000,
          });
        }
      }
    }
  }, [isError, error, toastOpen]);
  return accountQuery;
};
